import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useMember } from "../lib/member";
import { toast } from "sonner";
import { Flame } from "lucide-react";

// Member-tier OAuth callback. Mirrors AuthCallback but uses /portal/auth/session.
const MemberAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useMember();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const fragment = (location.hash || window.location.hash || "").replace(/^#/, "");
    const sessionId = new URLSearchParams(fragment).get("session_id");
    if (!sessionId) { navigate("/portal/login", { replace: true }); return; }
    (async () => {
      try {
        const r = await api.post("/portal/auth/session", { session_id: sessionId });
        await refresh();
        toast.success(`Welcome, ${r.data.member.name || r.data.member.email}.`);
        navigate("/portal", { replace: true, state: { member: r.data.member } });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Sign-in failed.");
        navigate("/portal/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#050505] text-[#F6F0E6]">
      <div className="icon-badge !h-14 !w-14 mb-6"><Flame className="h-7 w-7 text-[#F28C18] animate-pulse" strokeWidth={1.5} /></div>
      <div className="overline">Connecting</div>
      <div className="font-serif-display text-3xl mt-2">Lighting your altar…</div>
    </div>
  );
};

export default MemberAuthCallback;
